import "./index.client.scss";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { wagmiConfig } from "./config";
import { WagmiProvider } from "wagmi";
import { ErrorBoundry } from "@components";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://372869909264b1dcd0de919ca419c9b1@o4508014227685376.ingest.de.sentry.io/4508014229258320",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [],
  replaysSessionSampleRate: 0.5,
  replaysOnErrorSampleRate: 1.0,
});

const el = document.querySelector("#root");

if (el) {
  const root = createRoot(el);
  const queryClient = new QueryClient();

  root.render(
    <StrictMode>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundry>
            <App />
          </ErrorBoundry>
        </QueryClientProvider>
      </WagmiProvider>
    </StrictMode>
  );
} else {
  throw new Error("root element does not exist");
}
